// composables/queries/cbt/useCBTTests.ts
import { useListCbtTestsLazyQuery } from '@/types/vue-apollo-helpers';

import type { CbtTestPaginator, QueryListCbtTestsArgs } from '@/types/composition-functions';

export const useCBTTests = ({
  autoFetch = true,
  variables,
}: {
  autoFetch?: boolean;
  variables?: Ref<QueryListCbtTestsArgs | undefined> | (() => QueryListCbtTestsArgs);
}) => {
  const { result, loading, error, load, refetch } = useListCbtTestsLazyQuery(
    variables as QueryListCbtTestsArgs,
    { fetchPolicy: 'cache-and-network' },
  );
  if (autoFetch) load();

  const data = computed(() => result.value?.listCBTTests?.data || []);
  const paginatorInfo = computed(
    () => result.value?.listCBTTests?.paginatorInfo || null,
  ) as ComputedRef<CbtTestPaginator['paginatorInfo'] | null>;

  return {
    cbtTests: {
      data,
      paginatorInfo,
      loading,
      error,
      refetch,
    },
    load,
    refetch,
  };
};
